module.exports = __webpack_public_path__ + "static/media/8.5b062e1f.svg";